<script>
  import Intersection from "$lib/Intersection.svelte";
  export let block;

  const embed = block.primary.embed;
  const regex = new RegExp(/src="([^\s]*)"/gi);

  let url = "";
  if (embed.provider_name === "YouTube") {
    url =
      regex.exec(embed.html)[1].replace("youtube.com", "youtube-nocookie.com") +
      "&rel=0";
  } else {
    const [_1, _2, _3, id, h] = embed.embed_url.split("/");
    url = `https://player.vimeo.com/video/${id}?h=${h}&dnt=true`;
  }
</script>

<Intersection let:intersecting top={500} bottom={500}>
  <div
    class="h-0 w-full relative bg-darkgray"
    style="padding-bottom: {(embed.height / embed.width) * 100}%;"
  >
    {#if intersecting}
      <iframe
        title={embed.provider_name}
        class="absolute inset-0 w-full h-full"
        src={url}
        width="760"
        height="428"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      />
    {/if}
  </div>
</Intersection>
